export const COOKIE_KEY = '_fccs'; // Feather Cookie Consent Settings
